import GameData from './live';

export default GameData;
